import * as ko from 'knockout';

import BrandedPage from "../brandedPage";

import "./atkins-products.less"

import panic from '../../common/panic';
import { EnquiryFormBindable } from '../../common/forms/enquiryFormBindable';
import customerEnquiryFormTemplate from "../../templates/customerEnquiryForm.html";
import textInputEnquiryTemplate from "../../templates/horizontalForm/textInputEnquiry.html"
import compactSubmitButtonTemplate from "../../templates/horizontalForm/compactSubmitButton.html";
import selectEnquiryTemplate from "../../templates/horizontalForm/selectEnquiry.html";
import alertTemplate from "../../templates/alert.html";
import ProductsLoadResponse from '../../common/webHostClient/orderProcess/samplesLoadResponse';
import SamplesClient from '../../common/webHostClient/orderProcess/samplesClient';

class Products extends BrandedPage {

    public readonly usrSample: ko.Observable<string> = ko.observable("");
    public readonly ussSample: ko.Observable<string> = ko.observable("");
    public readonly usmEssentialSample: ko.Observable<string> = ko.observable("");
    public readonly usmStandardSample: ko.Observable<string> = ko.observable("");
    public readonly usmAdvancedSample: ko.Observable<string> = ko.observable("");
    private readonly samplesClient = new SamplesClient();
    public readonly enquiryForm: EnquiryFormBindable = new EnquiryFormBindable();

    public readonly usrProductPanelId = "usr-panel";
    public readonly usmProductPanelId = "usm-panel";
    public readonly ussProductPanelId = "uss-panel";

    public readonly visibleProductPanelId: ko.Observable<string> = ko.observable(null);
    public readonly usrProductPanelIsVisible: ko.Computed<boolean>;
    public readonly usmProductPanelIsVisible: ko.Computed<boolean>;
    public readonly ussProductPanelIsVisible: ko.Computed<boolean>;

    constructor()
    {
        super();

        this.usrProductPanelIsVisible = ko.computed(() => this.usrProductPanelId === this.visibleProductPanelId());
        this.usmProductPanelIsVisible = ko.computed(() => this.usmProductPanelId === this.visibleProductPanelId());
        this.ussProductPanelIsVisible = ko.computed(() => this.ussProductPanelId === this.visibleProductPanelId());
    }

    protected getTemplateHtmlSnippets(): string[] {
        return super.getTemplateHtmlSnippets().concat([ customerEnquiryFormTemplate, compactSubmitButtonTemplate, selectEnquiryTemplate, textInputEnquiryTemplate, alertTemplate ]);
    }

    protected async loadContentAsync(): Promise<void> {
        await super.loadContentAsync();

        this.setActiveNav(BrandedPage.whatWeOfferNavPage);

        let response: ProductsLoadResponse;
        try {
            response = this.samplesClient.LoadSamples();
        }
        catch (error)
        {
            console.error(error);
            panic('16c99b53-78a1-4bb2-a574-075ae3c0d829');
        }

        this.usrSample(response.usrSample.blobUrl);
        this.ussSample(response.ussSample.blobUrl);
        this.usmEssentialSample(response.usmEssentialSample.blobUrl);
        this.usmStandardSample(response.usmStandardSample.blobUrl);
        this.usmAdvancedSample(response.usmAdvancedSample.blobUrl);
    }

    protected async onLoadCompleteAsync(): Promise<void> {
        await super.onLoadCompleteAsync();

        if ("#" + this.usrProductPanelId === location.hash)
        {
            this.showUsrProductPanel();
        }
        else if ("#" + this.usmProductPanelId === location.hash)
        {
            this.showUsmProductPanel();
        }
        else if ("#" + this.ussProductPanelId === location.hash)
        {
            this.showUssProductPanel();
        }
    }

    public showUsrProductPanel()
    {
        if (this.visibleProductPanelId() == this.usrProductPanelId)
        {
            this.visibleProductPanelId("");
            return;
        }

        this.visibleProductPanelId(this.usrProductPanelId);
        this.scrollToPanel(this.usrProductPanelId);
    }

    public showUsmProductPanel()
    {
        if (this.visibleProductPanelId() == this.usmProductPanelId)
        {
            this.visibleProductPanelId("");
            return;
        }

        this.visibleProductPanelId(this.usmProductPanelId);
        this.scrollToPanel(this.usmProductPanelId);
    }

    public showUssProductPanel()
    {
        if (this.visibleProductPanelId() == this.ussProductPanelId)
        {
            this.visibleProductPanelId("");
            return;
        }

        this.visibleProductPanelId(this.ussProductPanelId);
        this.scrollToPanel(this.ussProductPanelId);
    }

    private scrollToPanel(panelId: string) {
        // Scroll to panel position, subtract from the offset to allow space for the header panel.
        window.scrollTo({
            top: $("#" + panelId).offset().top - 160,
            left: 0,
            behavior: 'smooth'
        });
    }
}

(new Products()).initialiseAsync();